<template>
  <div id="login">
    <div class="ipt_area">
      <div class="img_p">
        <img src="../../assets/images/3x/phone.png" alt=""><span style="padding-left: 0.2rem">{{qh_code}}</span>
      </div>
      <van-field label="" v-model="tel"/>
    </div>
    <div class="ipt_area ipt_area2">
      <div class="img_p">
        <img src="../../assets/images/3x/pass.png" alt="">
      </div>
      <van-field label="" value="" v-model="pasd" type="password"/>
    </div>
    <div class="ipt_text">
      <p  @click="smsLogin">{{$t('message.for_pass')}}</p>
    </div>
    <van-button type="default" block @click="getLogin">{{$t('message.determine')}}</van-button>
  </div>
</template>

<script>
  import {loginPassword} from "../../ports/port";

  export default {
    name: "login",
    data() {
      return {
        tel: '',
        pasd: '',
        qh_code:this.$qh
      }
    },
    methods:{
      getLogin(){
        //平台、设备和操作系统
        var system = {
          win: false,
          mac: false,
          xll: false
        };
        //检测平台
        var p = navigator.platform;
        system.win = p.indexOf("Win") == 0;
        system.mac = p.indexOf("Mac") == 0;
        system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
        if (!system.win || system.mac || system.xll) {
          this.$notify({
            type: 'danger',
            message: this.$t('message.use_phone')//请使用手机打开网页登录
          });
        }else{
           if(this.tel!=''&&this.pasd!=''){
             this.$store.commit('edit', true);//打开全局的loading
             loginPassword({phone: this.tel, userpwd: this.pasd, login_type: '6'})
               .then(res => {
                 this.$store.commit('edit', false);//关闭全局的loading
                 if (res.data.code == 200) {
                   let tk = JSON.stringify(res.data.data);
                   localStorage.setItem("tokenAll", tk);//本地保存token
                   this.$notify({type: 'success', message: this.$t('message.login_success'),duration: 1000,onClose:()=>{
                       this.$router.push('/home');
                     }});
                 } else {
                   this.$notify({type: 'danger', message: res.data.msg});
                 }
               })
               .catch(err=>{
                 this.$store.commit('edit',false);//关闭全局的loading
                 if(err.toString().indexOf('timeout')!=-1){
                   this.$toast({message:this.$t("message.service_timeout"),type:'danger',icon:'fail'});
                 }
               })
           }else{
             this.$toast({message:this.$t('message.tel_psd_rz')});
           }
        }
      },
      smsLogin(){
        this.$router.push('/auth/login')
      },
      editPsd(){
        this.$router.push('/editPsd')
      }
    }
  }
</script>

<style scoped lang="scss">
  #login {
    padding: 0.2rem 1.02rem;
    .ipt_area{
      position: relative;
      .img_p{
        position: absolute;
        z-index: 1;
        left: 0.45rem;
        top: 0;
        height:100%;
        display: flex;
        justify-content: center;
        align-items: center;
        >img{
          height: 20px;
        }
      }
    }
    .ipt_area2{
      position: relative;
      >img{
        left: 0.41rem;
      }
      .code_btn{
        background: $color;
        width: 3.31rem;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        border-bottom-right-radius: 8px;
        border-top-right-radius: 8px;
        color:#fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .ipt_text{
      margin-top: -0.1rem;
      font-size: 0.1rem;
      text-align: right;
      color: $color;
      margin-bottom: 0.61rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  /deep/ .van-cell.van-field {
    @include borderSty;
    margin: 0.4rem 0;
  }

  /deep/ .van-cell {
    line-height: 20px !important;
  }
  .van-button--default{
    @include defaultBtn;
  }
  /deep/ .van-field__control{
    padding-left: 1.29rem!important;
  }
  /deep/ .ipt_area2 .van-field__control{
    padding-left: 0.65rem!important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/auth/loginCode.vue